export default __webpack_public_path__ + "static/media/brand-details.f7522965.jpg";